import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46882224"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid d-flex" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "navbar-nav ms-auto" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Αρχική")
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Κατηγορίες")
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Ετικέτες")
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Χάρτης")
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Αναζήτηση")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand-lg", {'navbar-light': !_ctx.isNavbarDark(), 'navbar-dark': _ctx.isNavbarDark(), 'bg-light': !_ctx.isNavbarDark(), 'bg-primary': _ctx.isNavbarDark(), 'border-bottom': !_ctx.isNavbarDark()}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$store.getters.getSiteLogo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            height: "40",
            class: "me-2",
            src: _ctx.$store.getters.getSiteLogo,
            alt: "logo"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        class: _normalizeClass(["navbar-brand", _ctx.isNavbarDark() ? 'text-light' : 'text-primary']),
        href: "/"
      }, _toDisplayString(_ctx.$store.getters.getSiteTitle), 3),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isNavbarOpen = !_ctx.isNavbarOpen)),
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navbarNav",
        "aria-controls": "navbarNav",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, _hoisted_4),
      _createElementVNode("div", {
        class: _normalizeClass(["collapse navbar-collapse", {'show' : _ctx.isNavbarOpen}]),
        id: "navbarNav"
      }, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", {'active': this.$route.path === '/'}]),
              to: "/",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isNavbarOpen = false))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", {'active': this.$route.path === '/collection'}]),
              to: "/collection",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isNavbarOpen = false))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", {'active': this.$route.path.startsWith('/tags')}]),
              to: "/tags",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isNavbarOpen = false))
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", {'active': this.$route.path === '/map'}]),
              to: "/map",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isNavbarOpen = false))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _createElementVNode("li", _hoisted_14, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["nav-link", {'active': this.$route.path === '/search'}]),
              to: "/search",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isNavbarOpen = false))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ])
      ], 2)
    ])
  ], 2))
}